import styled from 'styled-components';

import { DetailItem as DI } from '../styled-components';
import { DetailValue as DV, DetailKey as DK } from '../../styled-components';

export const ContactsWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-bottom: 16px;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    min-width: 100%;
    border-bottom: 1px solid #EDEDED;
  }
`;

export const ContactItem = styled.span`
  padding: 0 16px 12px;
  cursor: pointer;
  
  &.active {
    position: relative;
    color: ${({ theme }) => theme.colors.mainDark};
  
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-bottom: 4px solid ${({ theme }) => theme.colors.fontTangerine};
    }
  }
`;

export const DetailsWrapper = styled.div`
  display: flex;
`;

export const DetailsInfoWrapper = styled.div`
  padding: 10px 0 0;
`;

export const DetailItem = styled(DI)`
  display: flex;
`;

export const DetailKey = styled(DK)`
  width: 170px;
  font-size: 13px;
  line-height: 16px;
  padding-left: 16px;
`;

export const DetailValue = styled(DV)`
  font-size: 13px;
  line-height: 16px;
  
  & p:last-child {
    margin-bottom: 0;
  }
`;

export const DetailValueItem = styled.p`
  cursor: pointer;
  padding-right: 14px;
  position: relative;

  & svg {
    display: none;

    &:hover {
      display: inline-block;
    }
  }

  &:hover {
    padding-right: 0;
    & svg {
      display: inline-block;
    }
  }
`;

export const EditButtonWrapper = styled.span`
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  padding: 0 16px 0 30px;
`;

export const EditButton = styled.span`
  display: flex;
  align-items: center;
  padding: 8px 10px;
  background: #FFF5EE;
  border-radius: 3px;
  cursor: pointer;
`;

export const EditButtonText = styled.p`
  font-size: 13px;
  padding-left: 6px;
  margin: 0;
  color: ${({ theme }) => theme.colors.fontTangerine};
`;

export const CopyWrapper = styled.span`
  padding: 10px;

  & svg {
    margin-top: -3px;
  }
`;

export const NoInfo = styled.p`
  font-size: 13px;
  font-weight: 500;
  padding: 0 15px;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondaryDark};
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-info/contact-details/styled-components.js